const module = {
  en: {
    generateReport: "Generate report",
  },
  pt: {
    generateReport: "Gerar relatório ",

  },
  es: {
    generateReport: " Generar el informe",

  }
};

export default {
  ...module
}



// WEBPACK FOOTER //
// ./src/app/module/i18nModule.js